<template>
    <div class="modal fade" id="hmMarkLeave" tabindex="-1" aria-labelledby="hmMarkLeaveLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg modal-dialog-centered">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="hmMarkLeaveLabel">Apply Leave</h5>
                    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                </div>
                <div class="modal-body">
                    <div class="row mt-1 g-3">
                        <div class="col-md-6">
                            <label for="address" class="form-label">Handyman</label>
                            <Select2
                                v-model="leaveData.handyman"
                                :options="handymans"
                                :settings="{ placeholder: 'Select Handyman'}"
                            />
                        </div>
                        <div class="col-md-3">
                            <label for="order_date" class="form-label">Start Date <span class="text-danger">*</span></label>
                            <BookingDatePicker
                                v-model="leaveData.startDate"
                                :format="'dd-MM-yyyy'"
                                :time-picker="false"
                                :display-marker="false"
                                :auto-apply="true"
                            ></BookingDatePicker>
                        </div>
                        <div class="col-md-3">
                            <label for="order_date" class="form-label">End Date <span class="text-danger">*</span></label>
                            <BookingDatePicker
                                v-model="leaveData.endDate"
                                :format="'dd-MM-yyyy'"
                                :time-picker="false"
                                :display-marker="false"
                                :auto-apply="true"
                                :min-date="momentObj(leaveData.startDate).format('YYYY-MM-DD')"
                            ></BookingDatePicker>
                        </div>
                    </div>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-danger" data-bs-toggle="modal" data-bs-target="#hmMarkLeave">Cancel</button>
                    <button
                        type="button"
                        class="btn btn-theme"
                        @click="saveLeave"
                        :disabled="processing"
                        :class="{ 'disabled cursor-not-allowed': !leaveData.handyman || processing }"
                        v-text="(processing ? 'Saving...' : 'Save')"
                    ></button>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment';
import Select2 from 'vue3-select2-component';
import { appMixin } from '../mixin/appMixin';
import BookingDatePicker from "./BookingDatePicker";
export default {
    components: {
        Select2,
        BookingDatePicker
    },
    mixins: [appMixin],
    data() {
        return {
            processing: false,
            minDate: moment().format('YYYY-MM-DD'),
            leaveData: {
                handyman:'',
                startDate: moment().format('YYYY-MM-DD'),
                endDate: moment().add(6, 'days').format('YYYY-MM-DD'),
            },
            handymans:[]
        }
    },
    mounted() {
        this.getHandymans();
    },
    watch: {
        'leaveData.startDate': {
            handler(val) {
                if (!val || !this.leaveData.endDate) return;
                
                const start = moment(val);
                const end = moment(this.leaveData.endDate);
                
                // Check if end date is before start date
                if (end.isBefore(start, 'day')) {
                    this.leaveData.endDate = start.add(1, 'days').format('YYYY-MM-DD');
                }
            }
        }
    },
    methods: {
        getHandymans() {
            axios.post('/admin/users/get-handyman-users')
                .then(response => {
                    //this.handymans = response.data;
                    if (Object.keys(response.data.users).length > 0) {
                        this.handymans = response.data.users.map((user) => {
                            return {
                                id: user.id,
                                text: user.name
                            }
                        });
                    }
                });
        },
        saveLeave() {
            axios.post('/admin/handymans/mark-leave', this.leaveData)
                .then(response => {
                    if (response.data.status === 'success') {
                        $('#hmMarkLeave').modal('hide');
                        this.leaveData.handyman = '';
                        this.leaveData.startDate = moment().format('YYYY-MM-DD');
                        this.leaveData.endDate = moment().add(6, 'days').format('YYYY-MM-DD');

                        const event = new CustomEvent('vue-to-jquery', {
                            detail: {
                                message: 'save-leave',
                            }
                        });
                        window.dispatchEvent(event);
                    }
                })
                .catch(error => {
                    this.processing = false;
                })
                .finally(() => {
                    this.processing = false;
                });
        }
    }
}
</script>
